import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAutoLogout = (timeoutMinutes = 1) => {
  const navigate = useNavigate();

  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    let timer;

    const resetTimer = () => {
      if (timer) clearTimeout(timer);
      
      // Set timeout for 5 minutes (300000 ms)
      timer = setTimeout(() => {
        // Clear all auth data
        localStorage.removeItem('auth_token');
        localStorage.removeItem('superadmin_user_id');
        localStorage.removeItem('superadmin_email');
        
        // Navigate to login
        navigate('/');
      }, timeoutMinutes * 60 * 6000); 
    };

    // Set initial timer
    resetTimer();

    // Add event listeners
    events.forEach(event => {
      document.addEventListener(event, resetTimer);
    });

    // Cleanup function
    return () => {
      if (timer) clearTimeout(timer);
      events.forEach(event => {
        document.removeEventListener(event, resetTimer);
      });
    };
  }, [navigate, timeoutMinutes]);
};